export default "__VITE_ASSET__BmEFNpRh__"